import React, { Dispatch, FC, SetStateAction, SyntheticEvent } from "react";

import { Tab } from "../../BreakdownByEntities";

import { Tabs } from "@components/common";

interface Component {
  activeTab: string;
  setActiveTab: Dispatch<SetStateAction<string>>;
  tabs: Tab[];
}

const Component: FC<Component> = ({ activeTab, setActiveTab, tabs }) => {
  const handleTabChange = (event: SyntheticEvent, value: string): void => {
    setActiveTab(value);
  };

  return (
    <Tabs<string>
      tabs={tabs.map((t) => ({ title: t.title, path: t.path }))}
      activeTab={activeTab}
      onChange={handleTabChange}
    />
  );
};

export default Component;
